import { render, staticRenderFns } from "./InviteTeammate.vue?vue&type=template&id=478e7954&scoped=true&lang=pug"
import script from "./InviteTeammate.vue?vue&type=script&lang=ts"
export * from "./InviteTeammate.vue?vue&type=script&lang=ts"
import style0 from "./InviteTeammate.vue?vue&type=style&index=0&id=478e7954&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e7954",
  null
  
)

/* custom blocks */
import block0 from "./Teammates.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FCompliance%2FTeammates%2FInviteTeammate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports